import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const images = [
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg",
];

const alts = [
  "réparation volet roulant Haguenau",
  "pose volet roulant Haguenau",
  "motorisation volet roulant Haguenau",
  "dépannage volet roulant Haguenau",
  "installation volet roulant Haguenau",
  "remplacement moteur Haguenau",
];

export default function Galerie() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Nos réalisations à Haguenau
          </h2>
          <p className="text-brand-text text-base md:text-lg max-w-2xl mx-auto">
            Découvrez quelques-unes de nos interventions de réparation et de pose de volet roulant à Haguenau.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {alts.map((alt, i) => (
            <div
              key={i}
              className="bg-brand-light rounded-xl border border-brand-border aspect-[4/3] overflow-hidden"
            >
              <ImagePlaceholder
                src={images[i]}
                alt={alt}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}